import { formatPrimaryPhaseMetricValue } from '../../statistics/charts/pipeline/lib/orderPrimaryPhaseMetric';

export const sumOrdersTotalPrice = (orders = []) =>
	(Array.isArray(orders) ? orders : []).reduce((sum, order) => sum + (Number(order?.totalPrice) || 0), 0);

export const formatLineCompareDrillTitle = (drill) => {
	if (!drill?.label) return '';
	if (drill.metricLabel) return `${drill.label} · ${drill.metricLabel}`;
	return drill.label;
};

export const formatLineCompareDrillOrdersAmount = (orders = []) =>
	formatPrimaryPhaseMetricValue(sumOrdersTotalPrice(orders), 'totalPrice');
